import React, { useEffect, useState } from "react";
import Calendly, { InlineWidget } from "react-calendly"
import { useLocation } from "react-router-dom";

export function CalendlyPage() {
  const query = new URLSearchParams(useLocation().search);
  const userId = query.get('id')
  const userName = query.get('name')
  const userSurname = query.get('surname')
  const userEmail = query.get('email');
  // console.log(userId, userName, userSurname, userEmail, query)

  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');

    const handleLoaded = () => {
      setTimeout(() => {
        setScriptLoaded(true);
      }, 1000);
    };

    if (existingScript) {
      if (existingScript.getAttribute("data-loaded")) {
        handleLoaded();
      } else {
        existingScript.addEventListener("load", handleLoaded);
      }
    } else {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      script.setAttribute("data-loaded", "true");

      script.onload = handleLoaded;

      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    // fetchUser(userId);
  }, [])

  async function fetchUser(userId) {
    // if (!userId || user) return;
    console.log("USERID", userId)
    // getUserById(userId)
    //   .then((res) => {
    //     setUser(res.data);
    //   })
    //   .catch((error) => {
    //     alertError({error, customMessage: "Could not get user"});
    //   })
  }

  return (
    <div style={{ backgroundColor: "#0a0a0a" }}>
      {scriptLoaded && userId && (
        <>
        <InlineWidget
          url="https://calendly.com/nutrexs?hide_gdpr_banner=1&background_color=0a0a0a&text_color=ffffff&primary_color=80c139"
          styles={{ height: 700 }}
          utm={{salesforce_uuid: userId}}
          prefill={{
            name: `${userName} ${userSurname}`,
            email: userEmail,
            firstName: userName,
            lastName: userSurname
          }}
        />
        </>
      )}
    </div>
  );
}